export default "__VITE_ASSET__68708cc6__"